<template>
    <div>
        <div class="page-container">
            <v-page-header
                :title="$t('使用腾讯文档填写员工信息')"
                :back="{
                    title: $t('批量导入新员工'),
                    goBack,
                }"
            />
            <div class="import-dialog">
                <div class="fix download-step">
                    <div class="fl download-step1"><span>1</span>{{ $t('打开腾讯文档模板并登录账号') }}</div>
                    <div class="fr download-template">
                        <v-button status="default" @click="openTencentDoc">{{ $t('打开腾讯文档模板') }}</v-button>
                    </div>
                </div>
                <div class="ovh">
                    <div class="download-step2"><span>2</span>{{ $t('将模板生成为副本') }}</div>
                </div>
                <div class="down-img">
                    <div class="fix download-back"></div>
                </div>
                <div class="ovh">
                    <div class="download-step2"><span>3</span>{{ $t('填写员工信息并导出为本地Excle表格') }}</div>
                </div>
                <div class="down-img">
                    <div class="fix download-back2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable prefer-destructuring */

import { Icon } from 'vhtml-ui';

const req = require.context('@/assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {},
    data() {},
    computed: {},
    mounted() {},
    methods: {
        goBack() {
            this.$router.push('/mng/org/importMembersExport');
        },
        openTencentDoc() {
            window.location.href = 'https://docs.qq.com';
        }
    }
};
</script>

<style lang="less">
@import '../styles/app';
</style>
